import React from 'react';
import { Box, Button, Typography } from '@mui/material';

// Chat Messenger had exactly one non-list state — the "No Messages Yet?" illustration —
// and it was shown whenever the array was empty, whatever the reason. A failed request
// and a genuinely empty list were pixel-identical, so when /admin/user/botusers started
// timing out under concurrency the column just looked empty. That is the whole of what
// was reported twice as "bots/users are not showing", and it took a live debugging
// session against production to tell the two apart.
//
// Three distinct states, so the screen says which one it is:
//   loading — a request is in flight and there is nothing to show yet
//   error   — the request failed; offer the retry rather than making someone reload
//   empty   — the server answered, and the answer is genuinely nothing

export const ListLoading = () => (
  <div className="modal-body overflowauto emptyList">
    <Box className="d-flex justify-content-center align-items-center h-100 p-20">
      <Typography variant="body2" color="text.secondary">
        Loading...
      </Typography>
    </Box>
  </div>
);

export const ListError = ({ onRetry, message }) => (
  <div className="modal-body overflowauto emptyList">
    <Box className="text-center d-flex justify-content-center align-items-center flex-column h-100 p-20">
      <Typography className="font-18 font-p fw-medium" sx={{ color: '#BE1F1F' }}>
        Couldn&apos;t load this list
      </Typography>
      <Typography
        className="font-12 font-m fw-normal text-black mt-2"
        sx={{ maxWidth: 260 }}
      >
        {message ||
          'The server took too long to respond. This is not an empty list — the request failed.'}
      </Typography>
      {onRetry && (
        <Button
          onClick={onRetry}
          sx={{
            mt: 2,
            background: '#BE1F1F',
            color: '#fff',
            fontSize: '14px',
            textTransform: 'capitalize',
            '&:hover': { background: '#9B1A1A' },
          }}
        >
          Retry
        </Button>
      )}
    </Box>
  </div>
);

export const ListEmpty = () => (
  <div className="modal-body overflowauto emptyList">
    <div className="text-center d-flex justify-content-center align-items-center flex-column h-100 p-20">
      <span>
        <img
          src="/assets/images/messages/no-messages-yet.svg"
          className="img-fluid"
          alt=""
          style={{ maxWidth: '70%', marginLeft: 'auto', marginRight: 'auto' }}
        />
      </span>
      <h3 className="font-18 font-p fw-medium text-black mt-3">No Messages Yet?</h3>
      <p className="font-12 font-m fw-normal text-black">
        Don’t worry – your perfect match might just be a conversation away. Stay active
        and discover exciting connections! Once you receive your messages, make sure to
        use the filters above.
      </p>
    </div>
  </div>
);
